import { EdicaoTermoNotificacao } from "@/contexts/fiscalizacao/termoNotificacao/pages/cadastramento/EdicaoTermoNotificacao";
import { ListaTermosNotificacao } from "@/contexts/fiscalizacao/termoNotificacao/pages/cadastramento/ListaTermosNotificacao";
import { NovoTermoNotificacao } from "@/contexts/fiscalizacao/termoNotificacao/pages/cadastramento/NovoTermoNotificacao";
import { VisualizacaoPrintTermoNotificacao } from "@/contexts/fiscalizacao/termoNotificacao/pages/impressao/VisualizacaoPrintTermoNotificacao";
import { NovoParecer } from "@/contexts/fiscalizacao/termoNotificacao/pages/saneamento/NovoParecer";
import { NovoSaneamento } from "@/contexts/fiscalizacao/termoNotificacao/pages/saneamento/NovoSaneamento";
import { SaneamentoTermosNotificacao } from "@/contexts/fiscalizacao/termoNotificacao/pages/saneamento/SaneamentoTermosNotificacao";
import { VisualizacaoSaneamento } from "@/contexts/fiscalizacao/termoNotificacao/pages/saneamento/VisualizacaoSaneamento";
import { VisualizacaoTermoNotificacao } from "@/contexts/fiscalizacao/termoNotificacao/pages/visualizacao/VisualizacaoTermoNotificacao";
import { Route } from "react-router";

// As rotas são renderizadas dentro do layout autenticado em app/routes.tsx.
// Retorna um Fragment (e não um componente) porque <Routes> só aceita
// <Route> ou Fragment como filhos diretos.
export function termoNotificacaoRoutes() {
  return (
    <>
      <Route
        path="/termos-notificacao/lista"
        element={<ListaTermosNotificacao />}
      />

      <Route
        path="/termos-notificacao/novo"
        element={<NovoTermoNotificacao />}
      />

      <Route
        path="/termos-notificacao/visualizar/:id"
        element={<VisualizacaoTermoNotificacao />}
      />

      <Route
        path="/termos-notificacao/lista/editar/:offlineId"
        element={<EdicaoTermoNotificacao />}
      />

      <Route
        path="/termos-notificacao/plano-acao"
        element={<SaneamentoTermosNotificacao />}
      />

      <Route
        path="/termos-notificacao/plano-acao/novo/:termoId"
        element={<NovoSaneamento />}
      />

      <Route
        path="/termos-notificacao/plano-acao/parecer/:termoId"
        element={<NovoParecer />}
      />

      <Route
        path="/termos-notificacao/plano-acao/visualizar/:id"
        element={<VisualizacaoSaneamento />}
      />
    </>
  );
}

// Rotas públicas (fora do layout autenticado).
export function termoNotificacaoPublicRoutes() {
  return (
    <>
      <Route
        path="/termos-notificacao/publico/:codigoVerificador/pdf"
        element={<VisualizacaoPrintTermoNotificacao />}
      />
    </>
  );
}
